<template>
    <div>
        <div class="main_content">
            <div class="WP_form">
                <div class="info_title">{{ $t('bankset.AccountType') }}</div>
                <div class="info_radio">
                    <van-radio-group v-model="formData.accountType">
                        <van-radio :name="item.enumName" checked-color="#D2EE00" v-for="(item, index) in columns" :key="index">{{
                            item.enumName }}</van-radio>
                    </van-radio-group>
                </div>
                <!-- 收款人名称 -->
				<div class="info_title">{{ $t('bankset.AccountName') }}</div>
				<div class="info_input">
					<a-input v-model="formData.accountName"
						:placeholder="$t('bankset.NameOfTheAccountHolder')"></a-input>
				</div>
				<!-- 收款人手机号 -->
				<div class="info_title">{{ $t('bankset.AccountPhone') }}</div>
				<div class="info_input">
					<a-input v-model="formData.accountPhone" type="number"
						:placeholder="$t('bankset.EnterPhoneNumber')"></a-input>
				</div>

				<!-- 收款账号 -->
				<div class="info_title">{{ $t('bankset.PayeeAccount') }}</div>
				<div class="info_input">
					<a-input v-model="formData.accountPayee" type="number"
						:placeholder="$t('bankset.PayeeAccount')"></a-input>
				</div>
				<!-- CCI -->
				<div class="info_title">{{ $t('bankset.InterbankAccountCode') }}</div>
				<div class="info_input">
					<a-input v-model="formData.cci" type="number"
						:placeholder="$t('bankset.InterbankAccountCode')"></a-input>
				</div>
                <!-- 渠道名称 -->
				<div class="info_title">{{ $t('bankset.ChannelName') }}</div>
				<div class="info_input p-r100" @click.stop="onShowChannelPopup">
					<a-input v-model="formData.channelName" disabled
						:placeholder="$t('bankset.PleaseSelectChannelName')" style="pointer-events: none;"></a-input>
					<div class="suffix">
						<div class="iconfont icon-youjiantou"></div>
					</div>
				</div>
                <div class="info_title" style="margin-bottom: 6px;">{{ $t('bankset.IdentityType') }}</div>
				<div class="info_radio">
					<van-radio-group v-model="formData.certType" size="36upx">
						<van-radio v-for="(item, index) in certTypes" :key="index" activeColor="#fdae00"
							:name="item.enumName">{{ item.enumName }}</van-radio>
					</van-radio-group>
				</div>
                <!-- 证件号 -->
				<div class="info_title">{{ $t('bankset.IDNumber') }}</div>
				<div class="info_input">
					<a-input v-model="formData.customerCert" :placeholder="$t('bankset.IDNumber')"
						type="number"></a-input>
				</div>
				<!-- 邮箱 -->
				<div class="info_title">{{ $t('bankset.email') }}</div>
				<div class="info_input">
					<a-input v-model="formData.email" :placeholder="$t('bankset.email')"></a-input>
				</div>
            </div>
            <div class="action_btn" @click="handleSubmit">
                <span>{{ $t('bankset.Save') }}</span>
            </div>
        </div>
        <channelPopup ref="channelPopup" :name="formData.channelName" @onConfirm="onChannelPopupConfirm">
        </channelPopup>
    </div>
</template>

<script>
import { Toast } from 'vant'
import { deepClone, checkStr } from '@/utils'
import {
    saveBankPeru,
    getBankPeru,
    updateBankPeru,
    getBankAccountTypePeru,
    getBankCertTypePeru
} from '@/api/withdraw'
import channelPopup from './modules/channelPopup.vue'
import md5 from 'md5'
export default {
    name: 'bankSetPeru',
    components: { channelPopup },
    data() {
        return {
            isFocus: 0,
            columns: [],
            certTypes: [],
            formData: {
                accountName: '',
                accountPayee: '',
                accountType: '',
                channelName: '',
                cci: '',
                email: '',
                certType: '',
                customerCert: '',
                withdrawPassword: '123456',
                withdrawPasswordVerify: '123456'
            },
            showPassword1: false,
            showPassword2: false,

            isShowChannelPopup: false,
            pwdForm: null
        }
    },
    methods: {
        close() {
            this.$emit('close')
        },
        open() {
            getBankPeru({}, {
                custom: {
                    toast: false
                }
            }).then(res => {
                if (res.code) return
                const uInfo = this.$store.getters.userInfo
                this.formData = {
                    ...res.result,
                    email: uInfo.email,
                    withdrawPassword: ''
                }
            })
            getBankAccountTypePeru().then((res) => {
                if (res.code) return
                const list = res.result
                this.columns = list
            })
            getBankCertTypePeru().then((res) => {
                if (res.code) return
                const list = res.result
                this.certTypes = list
            })
        },
        getFocus(num) {
            this.isFocus = num
        },
        onShowChannelPopup() {
            this.$refs.channelPopup.open()
        },
        onChannelPopupConfirm(e) {
            this.formData.channelName = e
            this.$forceUpdate()
        },
        async handleSubmit() {
            if (!this.formData.accountType) {
                Toast(this.$t('bankset.PleaseSelectAccountType'))
                return
            }
            const accountName = this.formData.accountName.trim()
            this.formData.accountName = accountName
            if (!accountName) {
                Toast(this.$t('bankset.InputAccountName'))
                return
            }
            if (!this.formData.accountPhone) {
                Toast(this.$t('bankset.PleaseEnterPhoneNumber'))
                return
            }
            const PhoneReg = /^\d{9}$/
            if (!PhoneReg.test(this.formData.accountPhone)) {
                Toast(this.$t('bankset.PhoneFormatPeru'))
                return
            }
            if (!this.formData.accountPayee) {
                Toast(this.$t('bankset.InputPayeeAccount'))
                return
            }
            if (!this.formData.cci) {
                Toast(this.$t('bankset.PleaseEnterInterbankAccountCode'))
                return
            }
            if (!this.formData.channelName) {
                Toast(this.$t('bankset.PleaseSelectChannelName'))
                return
            }
            if (!this.formData.certType) {
                Toast(this.$t('bankset.PleaseSelectIdentityType'))
                return
            }
            if (!this.formData.customerCert) {
                Toast(this.$t('bankset.PleaseEnterIDNumber'))
                return
            }
            const email = this.formData.email.trim()
            this.formData.email = email
            if (!this.formData.email) {
                Toast(this.$t('bankset.PleaseEnterEmail'))
                return
            }
            if (!checkStr(this.formData.email, 'email')) {
                Toast(this.$t('login.PleaseEnterEmailFormat'))
                return
            }

            const form = deepClone(this.formData)
            if (form.withdrawPassword) form.withdrawPassword = md5(form.withdrawPassword)
            if (form.withdrawPasswordVerify) form.withdrawPasswordVerify = md5(form.withdrawPasswordVerify)

            let result
            if (form.id) {
                result = await updateBankPeru(form)
            } else {
                result = await saveBankPeru(form)
            }
            Toast(result.message)
            if (result.code) return
            this.$emit('succ')
            this.close()
        },
        inputInt(e, key) {
            const val = e.toString().replace(/[^\d]/g, '')
            this.formData[key] = val
        }
    }
}
</script>

<style scoped lang="scss">
.main_content {
    overflow: auto;

    .WP_form {
        padding: 0 .28rem;

        .info_title {
            margin-bottom: .18rem;
            font-size: .28rem;
            color: var(--aurora-ink);
            margin-top: .24rem;
            text-align: left;
        }

        .info_radio {
            width: 100%;
            font-size: .26rem;
            font-weight: 400;
            padding-right: .28rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: relative;

            ::v-deep .van-radio-group {
                display: flex;
                flex-wrap: wrap;
            }

            ::v-deep .van-radio {
                margin-bottom: .18rem;
                margin-right: .5rem;
                .van-radio__label {
                    color: var(--aurora-muted);
                }

                .van-radio__icon--checked {
                    &+.van-radio__label {
                        color: var(--aurora-ink);
                    }
                }
            }
        }

        .info_input {
            ::v-deep input::-webkit-outer-spin-button {
                -webkit-appearance: none;
            }

            ::v-deep input::-webkit-inner-spin-button {
                -webkit-appearance: none;
            }

            ::v-deep input[type='number'] {
                -moz-appearance: textfield;
            }

            ::v-deep .ant-input-suffix {
                .ant-input-clear-icon {
                    color: var(--aurora-muted);
                    font-size: .32rem;
                    margin-right: .1rem;
                }

                .icon-xiangyou {
                    margin-right: .1rem;
                    font-size: .3rem;
                    color: var(--aurora-muted);
                }
            }

            ::v-deep .ant-input-password {
                .ant-input {
                    padding-right: 1rem;
                }

                .ant-input-suffix {
                    .ant-input-password-icon {
                        margin-right: .1rem;
                        font-size: .3rem;
                        color: var(--aurora-muted);
                    }
                }
            }

            ::v-deep .ant-input {
                background-color: var(--aurora-surface) !important;
                border-radius: 0.14rem;
                font-size: 0.29rem;
                height: .8rem;
                padding: 0px 0.24rem !important;
                color: var(--aurora-ink);
                border: .02rem solid var(--aurora-line) !important;
                padding-left: .28rem !important;

                &:focus {
                    background-color: transparent;
                    border-color: var(--aurora-accent) !important;
                }

                &::-webkit-input-placeholder {
                    /* WebKit browsers */
                    font-size: .28rem;
                    color: var(--aurora-muted);
                    opacity: .7;
                    font-weight: 100;
                }

                &:-moz-placeholder {
                    /* Mozilla Firefox 4 to 18 */
                    font-size: .28rem;
                    color: var(--aurora-muted);
                }

                &::-moz-placeholder {
                    /* Mozilla Firefox 19+ */
                    font-size: .28rem;
                    color: var(--aurora-muted);
                }

                &:-ms-input-placeholder {
                    /* Internet Explorer 10+ */
                    font-size: .28rem;
                    color: var(--aurora-muted);
                }
            }
        }
    }

    .action_btn {
        width: 6rem;
        height: .7rem;
        border-radius: .15rem;
        margin: .3rem auto;
        margin-top: .58rem;
        font-family: eryawenrunti;
        font-weight: 600;
        font-size: .28rem;
        color: var(--aurora-on-primary);
        text-align: center;
        line-height: .7rem;
        cursor: pointer;
        background-color: var(--aurora-accent);

        &.disabled {
            background: var(--aurora-lilac);
            color: var(--aurora-subtle);
            cursor: not-allowed;
            box-shadow: 0 .06rem 0 0 var(--aurora-shadow-color), 0 .02rem .03rem 0 var(--aurora-shadow-color), 0 .02rem .03rem 0 var(--aurora-shadow-color);
        }
    }
}
</style>
